import { useState, useEffect } from "react";

import Breadcrumb from "./Breadcrumb";
import { bookingDetailsUrl } from "../services/adminApiService/venueManagerApi/venueManagerApi";
import RemarkModal from "./RemarkModal";
import Swal from "sweetalert2";
import { useParams, useLocation } from "react-router-dom";
import { CgDanger } from "react-icons/cg";
import { Button } from "react-bootstrap";
import { IoCheckmarkCircleOutline } from "react-icons/io5";


function BookingDetails() {
  // console.log("khsbdjhbj", bookingDetailsUrl("USP285Kumari"));
  // const id = localStorage.getItem("venueManagerBookingId");
  const [bookingId, setBookingId] = useState("");
  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const id = pathSegments[pathSegments.length - 1];

  const [loading, setLoading] = useState(false);
  const [bookingDetails, setBookingDetails] = useState({});
  const [remarkModal, setRemarkModal] = useState(false);

  const fetchBookingDetails = async (id) => {
    setLoading(true);
    try {
      const response = await bookingDetailsUrl(id);
      // console.log("API response:", response.data); // See the structure

      // If response.data is the array you want to map
      setBookingDetails(response.data.data);
      setBookingId(response.data.data.booking_id);

      // If it's nested, e.g. response.data.bookings
      // setBookingDetails(response.data.bookings);
    } catch (error) {
      console.error("Booking fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookingDetails(id);
  }, [remarkModal]);

  function formatDateToMonthDayYear(dateString) {
    if (!dateString) return "";

    const date = new Date(dateString);

    // Check if date is valid
    if (isNaN(date)) return "";

    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long", // full month name: "May"
      day: "numeric",
    });
  }

  function convertTo12Hour(time24) {
    if (!time24) return "";

    const [hourStr, minuteStr] = time24.split(":");
    let hour = parseInt(hourStr, 10);
    const minute = minuteStr;

    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12;
    if (hour === 0) hour = 12;

    return `${hour}:${minute} ${ampm}`;
  }

  const handleClose = () => {
    setRemarkModal(false);
  };

  return (
    <>
      {remarkModal && (
        <RemarkModal
          show={remarkModal}
          handleClose={handleClose}
          id={bookingId}
        />
      )}
      <div className="booking-details-container">
        <div className="d-flex justify-content-center mb-4">
         {bookingDetails?.booking_status == "Completed" ? <div className="alert-box d-flex align-items-center p-2" style={{backgroundColor: "#edf6f0", borderRadius: "15px"}}>
           <IoCheckmarkCircleOutline 
              style={{
                color: "rgba(74, 165, 100, 1)",
                fontSize: "25px",
                padding: "0px 5px 5px 0px",
              }}
            />
            <span style={{ color: "rgba(74, 165, 100, 1)", fontSize: "15px" }}>
             Payment Successful, Grant Access.
            </span>
          </div> : <div className="alert-box d-flex align-items-center">
            <CgDanger
              style={{
                color: "#b95f00",
                fontSize: "20px",
                padding: "0px 5px 5px 0px",
              }}
            />
            <span style={{ color: "#b95f00", fontSize: "15px" }}>
              The ticket has been successfully generated. Please collect the
              payment.
            </span>
          </div> }
        </div>
        <div className="booking-card">
          <h1 className="title">Booking Details</h1>
          <Breadcrumb
            breadCrumbPayload={[
              { title: "Home", url: "", isActive: false },
              { title: "Customer Bookings", url: "", isActive: false },
              { title: "USP01BALLU", url: "", isActive: true },
            ]}
          />

          <h2 className="section-title">Booking Information</h2>

          <div className="booking-info-layout">
            <div className="left-section">
              <img
                src="/logo/Play_Ground.png"
                alt="Play Ground"
                className="playground-image"
              />

              <div className="venue-info">
                <h3>{bookingDetails?.venue?.venue_name || ""}</h3>
                <p className="text-muted">{bookingDetails?.address || ""}</p>

                <div className="details-grid">
                  <div>
                    <h4>Customer Details</h4>
                    <p>
                      <strong>Name:</strong>{" "}
                      {(bookingDetails?.user?.first_name || "") +
                        " " +
                        (bookingDetails?.user?.last_name || "")}
                    </p>
                    <p>
                      <strong>Email Address:</strong>{" "}
                      {bookingDetails?.user?.email || ""}
                    </p>
                    <p>
                      <strong>Phone Number:</strong> +91{" "}
                      {bookingDetails?.user?.mobile || ""}
                    </p>
                    <p>
                      <strong>Field of Play:</strong>{" "}
                      {bookingDetails?.venue?.venue_name || ""}
                    </p>
                  { bookingDetails?.booking_status === "Completed" && <p>
                      <strong>Payment Gateway:</strong>{" "}
                      {bookingDetails?.payment_plateform_type || ""}
                    </p>}
                   { bookingDetails?.booking_status === "Completed" && <p>
                      <strong>Payment Method:</strong>{" "}
                      {bookingDetails?.payment_method || ""}
                    </p>}
                  </div>
                  <div>
                    <h4>Booking Details</h4>
                    <p>
                      <strong>Created On:</strong>{" "}
                      {formatDateToMonthDayYear(bookingDetails?.createdAt) ||
                        ""}
                    </p>
                    <p>
                      <strong>Date:</strong>{" "}
                      {formatDateToMonthDayYear(bookingDetails?.slot_to_date) ||
                        ""}
                    </p>
                    <p>
                      <strong>Time Slot:</strong>{" "}
                      {(bookingDetails?.slot_from_time || "") +
                        "-" +
                        (bookingDetails?.slot_to_time || "")}
                    </p>
                    <p>
                      <strong>Sport:</strong>{" "}
                      {bookingDetails?.sport?.sport_name || ""}
                    </p>
                    <p>
                      <strong>Amount:</strong> ₹{" "}
                      {bookingDetails?.total_ammount || ""}
                    </p>
                    <p>
                      <strong>Payment:</strong>{" "}
                      <span
                        style={{
                          fontWeight: 500,
                          // fontSize: "14px",
                          padding: "5px 10px 5px 10px",
                          borderRadius:"15px",
                          backgroundColor:
                            bookingDetails?.booking_status === "Completed"
                              ? "#eaf5ec"
                              : bookingDetails?.booking_status === "Pending"
                              ? "#fff4e5"
                              : bookingDetails?.booking_status === "Failed"
                              ? "#f8d7da"
                              : bookingDetails?.booking_status === "Canceled"
                              ? "#fce4ec"
                              : bookingDetails?.booking_status === "Inprocess"
                              ? "#e3f2fd"
                              : "#e0e0e0", // fallback
                          color:
                            bookingDetails?.booking_status === "Completed"
                              ? "#2e7d32"
                              : bookingDetails?.booking_status === "Pending"
                              ? "#a85c00"
                              : bookingDetails?.booking_status === "Failed"
                              ? "#a10000"
                              : bookingDetails?.booking_status === "Canceled"
                              ? "#ad1457"
                              : bookingDetails?.booking_status === "Inprocess"
                              ? "#1565c0"
                              : "#000000", // fallback
                        }}
                      >
                        {bookingDetails?.booking_status === "Pending"
                          ? "Pay at Venue"
                          : bookingDetails?.booking_status === "Completed"
                          ? "Completed"
                          : bookingDetails?.booking_status === "Failed"
                          ? "Failed"
                          : bookingDetails?.booking_status === "Canceled"
                          ? "Canceled"
                          : bookingDetails?.booking_status === "Inprocess"
                          ? "InProcess"
                          : "Unknown"}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="right-section">
              <h3>{bookingDetails?.venue?.venue_name || ""}</h3>
              <p className="text-muted">{bookingDetails?.address || ""}</p>

              <div className="booking-id-box">
                <span>#Booking ID</span>
                <br />
                <span className="booking-id">
                  {bookingDetails?.booking_id || ""}
                </span>
              </div>

              <div className="qr-section">
                <img
                  src={bookingDetails?.qr_code_link || "/logo/QR.png"}
                  alt="QR Code"
                  className="qr-code"
                  crossOrigin="anonymous"
                />

                <div className="qr-details">
                  <p>
                    <strong>Date:</strong>{" "}
                    {formatDateToMonthDayYear(bookingDetails?.slot_to_date) ||
                      ""}
                  </p>
                  <p>
                    <strong>Time Slot:</strong>{" "}
                    {(bookingDetails?.slot_from_time || "") +
                      "-" +
                      (bookingDetails?.slot_to_time || "")}
                  </p>
                  <p>
                    <strong>Sport:</strong>{" "}
                    {bookingDetails?.sport?.sport_name || ""}
                  </p>
                </div>
              </div>

              <p className="field-display">
                <strong>Field of Play: </strong>
                {bookingDetails?.venue?.venue_name || ""}
              </p>

              <div className="user-avatar">
                <img
                  src={
                    bookingDetails?.venue?.image_url ||
                    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQxOX4mkcW8pH9FbpI9rTBkokiMxSY2GJ3eyw&s"
                  }
                  alt="avatar"
                  crossOrigin="anonymous"
                />
                <div>
                  <p className="avatar-name mt-2 mb-0">
                    {(bookingDetails?.user?.first_name || "") +
                      " " +
                      (bookingDetails?.user?.last_name || "")}
                  </p>
                  <p className="avatar-email">
                    {bookingDetails?.user?.email || ""}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {bookingDetails?.booking_status == "Pending" ? <div className="d-flex align-items-center justify-content-center gap-3">
          <button className="custom-button-cancel">Cancel</button>
          <button
            className="custom-button-continue"
            onClick={() => setRemarkModal(true)}
          >
            Continue
          </button>
        </div> : (
          <div className="d-flex align-items-center justify-content-end gap-3">
          {/* <button className="custom-button-cancel">Cancel</button> */}
          <button
            className="custom-button-continue"
            onClick={() => window.location.href = "/booking-list"}
          >
            Back
          </button>
        </div>
        )}
      </div>
    </>
  );
}

export default BookingDetails;
